import React from 'react';
import styled from 'styled-components';

import { Container } from '../../Hoc/elements';
import StickySidebar from '../../Components/Layout/StickySidebar';
import LeftJobSection from './LeftJobSection/LeftJobSection';
import MainJobSection from './MainJobSection/MainJobSection';
import RightSection from './RightJobSection/RightSection';
import { useI18n } from '../../i18n/I18nProvider';

const Jobs = () => {
  const { t } = useI18n();
  return (
  <Page>
    <Container>
      <Header>
        <h1>{t('jobs.pageTitle')}</h1>
      </Header>
      <HomeLayout>
        <StickySidebar>
          <LeftJobSection />
        </StickySidebar>
        <MainColumn>
          <MainJobSection />
        </MainColumn>
        <RankingColumn>
          <RightSection />
        </RankingColumn>
      </HomeLayout>
    </Container>
  </Page>
  );
};

const Page = styled.main`
  min-height: calc(100vh - 5rem);
  padding: clamp(1rem, 3vw, 2.5rem) 0 5rem;
  background: var(--color-background);
  color: var(--color-text);
`;

const Header = styled.header`
  margin: 0 auto 1.4rem;
  padding: clamp(1rem, 2.5vw, 1.45rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: linear-gradient(135deg, #fff 0%, #faf9f7 100%);
  box-shadow: var(--shadow-xs);

  h1 {
    margin: 0;
    color: var(--color-mainDark);
    font-size: clamp(1.65rem, 4vw, 2.35rem);
  }

  p {
    max-width: 45rem;
    margin: 0.65rem 0 0;
    color: var(--color-text-muted);
    line-height: 1.5;
  }
`;

const HomeLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(17rem, 18rem) minmax(0, 1fr);
  align-items: start;
  gap: clamp(1rem, 2vw, 1.5rem);

  & > * {
    min-width: 0;
  }

  & > :last-child {
    display: none;
  }

  @media (min-width: 112rem) {
    grid-template-columns: minmax(17rem, 18rem) minmax(0, 1fr) minmax(17rem, 18rem);

    & > :last-child {
      display: grid;
    }
  }

  @media (max-width: 74rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const MainColumn = styled.section`
  min-width: 0;
  align-self: start;
`;

const RankingColumn = styled.aside`
  min-width: 0;
  align-self: start;
`;

export default Jobs;
